// palette obtained from ColorBrewer: https://colorbrewer2.org/#type=qualitative&scheme=Paired&n=12
// and mixed with material design palette https://www.materialpalette.com/colors\
// for a simpler color picker use https://www.materialpalette.com/colors/
export const qualitative = [
    '#984ea3',
    '#ff7f00',
    '#377eb8',
    '#33a02c', // green
    '#f44336', // red 500
    '#fdbf6f', // creme
    '#b15928', // light brown
    '#cab2d6', // lavender
    '#3f51b5', // indigo 500
    '#009688', // teal 500
    '#a6cee3', // light blue
    '#ab47bc', // purple 400
    '#90a4ae', // blue grey 300
    '#673ab7', // deep purple 500
    '#00bcd4', // cyan 500
    '#e91e63', // pink 500
    '#aeea00', // lime green A700
    '#ffc107', // amber 500
    '#ff5722', // deep orange 500
    //additional colors added
    '#880e4f', //dark purple
    '#f48fb1', // light pink
    '#1b5e20', //dark green
    '#ffab40', // med orange
    '#b71c1c', //dark red
]

export const getColorByFacilityType = facilityType => {
    switch (facilityType) {
        case 'C':
            return { fill: '#964B00', stroke: '#964B00' } // Commercial/Industrial
        case 'D':
            return { fill: '#90D5FF', stroke: '#90D5FF' } // Domestic
        case 'I':
            return { fill: 'purple', stroke: 'purple' } // Irrigation
        case 'L':
            return { fill: 'pink', stroke: 'pink' } // Observation (Ground Water Levels)
        case 'O':
            return { fill: '#fdda0d', stroke: '#fdda0d' } // Other
        case 'P':
            return { fill: 'white', stroke: 'blue' } // Public Water Supplier with Spacing Protection
        case 'Q':
            return { fill: '#FFB343', stroke: '#FFB343' } // Monitoring (Ground Water Quality)
        case 'S':
            return { fill: 'green', stroke: 'green' } // Livestock
        case 'PWSU':
            return { fill: '#000080', stroke: '#000080' } // Public Water Supplier without Spacing Protection
        case 'H':
            return { fill: 'red', stroke: 'red' } // Public Water Supplier without Spacing Protection
        default:
            return { fill: 'grey', stroke: 'grey' } // Default color
    }
}
